import { render } from "./ReleaseGuide.vue?vue&type=template&id=59c9c1ba&scoped=true&ts=true"
import script from "./ReleaseGuide.vue?vue&type=script&lang=ts"
export * from "./ReleaseGuide.vue?vue&type=script&lang=ts"

import "./ReleaseGuide.vue?vue&type=style&index=0&id=59c9c1ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c9c1ba"]])

export default __exports__